import PropTypes from 'prop-types'

const EventMap = ({ coachFacility }) => {
  const {
    latitude,
    longitude,
    name: facilityName = '',
    zipCode = '',
  } = coachFacility

  const hasLatLng = (!!latitude && !!longitude) && (latitude !== 0 && longitude !== 0)
  if (!hasLatLng && !zipCode) return null

  const encodedFacilityInfo = encodeURIComponent(`${facilityName}${!hasLatLng ? ` ${zipCode}` : ''}`)

  const mapBaseUrl = `https://www.google.com/maps/embed/v1/place?key=${process.env.GOOGLE_APIS_CLIENT_KEY}&q=${encodedFacilityInfo}`
  const mapSrc = hasLatLng ? `${mapBaseUrl}&center=${latitude},${longitude}&zoom=16` : `${mapBaseUrl}`

  return (
    <iframe
      aria-hidden="true"
      aria-label="Facility Location"
      width="100%"
      height="360"
      style={{ marginTop: '1rem', border: 'none' }}
      src={mapSrc}
      title={`${coachFacility.name} Facility Location`}
    />
  )
}

EventMap.propTypes = {
  coachFacility: PropTypes.shape({
    name: PropTypes.string,
    zipCode: PropTypes.string,
    latitude: PropTypes.number,
    longitude: PropTypes.number,
  }),
}

export default EventMap
